// extracted by mini-css-extract-plugin
export default {"title":"AboutMeSettingsCard_title__yRiRd"};